module.exports = __webpack_public_path__ + "static/img/11.e6f5208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ajbz/11.png
// module id = Ss+g
// module chunks = 0